module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">{{title}}</h3>\n</div>\n<div class=\"modal-body\" style=\"line-break: normal\">\n  <p>{{content}}</p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">\n    关闭\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/uba/model/show.html
// module id = 399
// module chunks = 0